import React from "react"
import StandardButton from '../app_components/StandardButton'

class MeetingExchangeButton extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      exists: undefined,
    }
    this.addToLex = this.addToLex.bind(this)
    this.removeFromLex = this.removeFromLex.bind(this)
  }

  componentDidMount() {
    $.ajax({
      url: `../check_meetings_exchanges`,
      dataType: 'JSON',
      type: 'POST',
      header: {
        'Content-Type': 'application/json'
      },
      data: {
        meeting_id: this.props.meetingId,
        exchange_id: this.props.topicId,
      },
      success: (data) => {
        if(JSON.parse(data.data.meeting_exchange).length > 0) {
          this.setState({
            exists: true,
          })
          return
        }
        this.setState({
          exists: false
        })
        return
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  addToLex() {
    $.ajax({
      url: `../add_meetings_exchange`,
      dataType: 'JSON',
      type: 'POST',
      header: {
        'Content-Type': 'application/json'
      },
      data: {
        meeting_id: this.props.meetingId,
        exchange_id: this.props.topicId
      },
      success: (data) => {
          this.setState({
            exists: true,
          })
          return
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  removeFromLex() {
    $.ajax({
      url: `../remove_meetings_exchange`,
      dataType: 'JSON',
      type: 'DELETE',
      header: {
        'Content-Type': 'application/json'
      },
      data: {
        meeting_id: this.props.meetingId,
        exchange_id: this.props.topicId
      },
      success: (data) => {
          this.setState({
            exists: false,
          })
          return
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }


    render() {
      if(this.state.exists === true) {
        return(
          <div className="activityCard__meetingAction">
            <StandardButton
              alert={true}
              fullWidth={true}
              onClick={this.removeFromLex}
              text="Remove from Lex"
            />
          </div>
        )
      } else if (this.state.exists === false) {
        return(
          <div className="activityCard__meetingAction">
            <StandardButton
              primary={true}
              fullWidth={true}
              onClick={this.addToLex}
              text="Add to Lex"
            />
          </div>
        )
      }
      return null

    }

}

export default MeetingExchangeButton;
